import GoBackButton from '@/common/components/GoBackButton';
import LogRequestShow from '@/common/components/LogRequestShow';
import { useEstablishmentUser } from '@/common/hooks/queries/useEstablishmentUser';
import useEstablishmentCompany from '@/features/establishments/hooks/useEstablishmentCompany';
import { ChevronsRightIcon } from 'lucide-react';
import { useParams } from 'react-router-dom';

const ActionsHistoryShow = () => {
  const { establishmentId, id: userId } = useParams();

  const { data: establishment } = useEstablishmentCompany(establishmentId || '')

  const { data: establishmentUser } = useEstablishmentUser({ id: userId || '' });

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div className="flex gap-x-4 items-center">
          <GoBackButton
            fallback={`/establishments/${establishmentId}/users/${userId}/actionsHistory`}
            searchLastRouteFromFallback
          />

          <p className="text-white-400 font-normal">
            {establishment?.general_information?.fantasy_name}
          </p>

          <ChevronsRightIcon color="#ffffffb3" />

          <h2>
            {establishmentUser?.full_name}
          </h2>
        </div>
      </div>

      <div className="h-[calc(100vh-64px-32px-40px)]">
        <LogRequestShow />
      </div>
    </div>
  );
};

export default ActionsHistoryShow;
